/**
 * True when ChaosKitchen is running as an installed PWA (home screen / TWA),
 * not a regular browser tab.
 */
export function isStandalonePWA(): boolean {
  if (typeof window === "undefined") return false;

  const nav = window.navigator as Navigator & { standalone?: boolean };
  if (nav.standalone === true) return true;

  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  if (window.matchMedia("(display-mode: window-controls-overlay)").matches) return true;

  if (typeof document !== "undefined" && document.referrer.startsWith("android-app://")) {
    return true;
  }

  return false;
}
